module.exports = __webpack_public_path__ + "img/tokuten_ico3.e41e90f7.png";